// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme) {
	return {
		MuiTableCell: {
			styleOverrides: {
				root: {
					fontSize: '13px',
					padding: '5px 12px',
					borderColor: theme.palette.divider,
				},
				head: {
					fontSize: 13,
					fontWeight: 500,
					// padding: 12,
					backgroundColor: '#f6f5f5',
					color: '#000000e0',
				},
			},
		},
	};
}
